import _memoize from 'lodash/memoize';
import { FONT, getFont } from '@tornado-rdk/typography';
import { makeDefaultStylingContext } from '../../../../tornado/utils/style';
import { MAX_TEXT_WIDTH } from '../metadata.constants';
import { genericTextStyle } from '../metadata.style';
import { CSA_ICON_SIZE, CSA_ICON_MARGIN } from './metadataTitle.constants';

export const defaultContext = makeDefaultStylingContext();

export const getCSAIconViewBox = _memoize(screenSize => ({
  h: CSA_ICON_SIZE[screenSize],
  w: CSA_ICON_SIZE[screenSize],
}));

export const getInitialStyle = (context = defaultContext) => {
  const { screenSize } = context;
  const wordWrapWidth = MAX_TEXT_WIDTH[screenSize];
  const titleFont = getFont(FONT.KINSHASA_1, screenSize);

  return {
    FlexContainer: {
      flex: { direction: 'row', alignItems: 'center' },
      Title: {
        text: {
          wordWrapWidth,
          ...genericTextStyle,
          ...titleFont,
        },
      },
      CsaIcon: {
        visible: false,
        flexItem: {
          marginLeft: CSA_ICON_MARGIN[screenSize],
        },
      },
    },
  };
};
